var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { styledComponents } from '@datashop/theme';
import { positionHelper } from '@datashop/utils';
import RefWrapper from './RefWrapper';
var styled = styledComponents.default, withProps = styledComponents.withProps;
var getPosition = positionHelper.getPosition, isInViewport = positionHelper.isInViewport;
var Position;
(function (Position) {
    Position["Top"] = "TopCenter";
    Position["Right"] = "RightCenter";
    Position["Bottom"] = "BottomCenter";
    Position["Left"] = "LeftCenter";
})(Position || (Position = {}));
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var TooltipWrapper = withProps(styled.div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  padding: 8px 16px;\n  border-radius: 4px;\n  position: absolute;\n  z-index: 2147483647;\n  background: ", "\n  ", "\n}\n"], ["\n  color: ", ";\n  padding: 8px 16px;\n  border-radius: 4px;\n  position: absolute;\n  z-index: 2147483647;\n  background: ", "\n  ",
    "\n}\n"])), function (props) { return props.theme.datashop.palette.white.main; }, function (props) { return props.theme.datashop.palette.night.main; }, function (props) {
    return props.arrow &&
        "&:after{\n      content: ' ';\n      position: absolute;\n      border-width: 5px;\n      border-style: solid; \n      " + getTooltipArrowStyle(props.position) + "}";
});
var getTooltipArrowStyle = function (position) {
    switch (position) {
        case 'Top':
            return "\n          left: 50%;\n          top: 100%; \n          margin-left: -5px;\n          border-color: black transparent transparent transparent;";
        case 'Left':
            return "\n          left: 100%;\n          top: 50%; \n          margin-top: -5px;\n          border-color: transparent transparent transparent black;";
        case 'Right':
            return "\n          right: 100%;\n          top: 50%; \n          margin-top: -5px;\n          border-color: transparent black transparent transparent;";
        default:
            return "\n          left: 50%;\n          bottom: 100%; \n          margin-left: -5px;\n          border-color: transparent transparent black transparent;";
    }
};
var Tooltip = (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.timer = null;
        _this.setTooltipPosition = function (position) {
            var tooltip = _this.tooltipRef.current;
            var trigger = ReactDOM.findDOMNode(_this.triggerRef.current);
            return getPosition(position, trigger, tooltip, {
                vertical: position === 'TopCenter' || position === 'BottomCenter' ? 8 : 0,
                horizontal: position === 'LeftCenter' || position === 'RightCenter' ? 8 : 0,
            }, !!_this.props.appendToBody);
        };
        _this.setTooltipStyle = function () {
            if (!_this.triggerRef.current || !_this.tooltipRef.current) {
                return;
            }
            var positionType = _this.props.position;
            var tempPosition;
            var positionFound = false;
            var trigger = ReactDOM.findDOMNode(_this.triggerRef.current);
            var position = _this.setTooltipPosition(Position[positionType]);
            if (isInViewport(_this.tooltipRef.current, position, _this.props.appendToBody, trigger)) {
                positionFound = true;
            }
            else {
                Object.keys(Position).some(function (positionTemp) {
                    tempPosition = _this.setTooltipPosition(Position[positionTemp]);
                    var inViewport = isInViewport(_this.tooltipRef.current, position, _this.props.appendToBody, trigger);
                    if (inViewport) {
                        position = tempPosition;
                        positionFound = true;
                        positionType = positionTemp;
                    }
                    return inViewport;
                });
            }
            if (!positionFound) {
                position = _this.setTooltipPosition(Position.Bottom);
                positionType = 'Bottom';
            }
            var styleObject = {
                left: position.left + 'px',
                top: position.top + 'px',
            };
            var style = __assign({ position: 'absolute' }, styleObject);
            _this.setState({
                arrowPosition: positionType,
                position: position,
                style: style,
            });
        };
        _this.handleMouseLeave = function (event) {
            if (_this.timer) {
                window.clearTimeout(_this.timer);
                _this.timer = null;
            }
            if (_this.state.open) {
                _this.setState({ open: false });
                if (_this.props.children.props.onMouseLeave) {
                    _this.props.children.props.onMouseLeave(event);
                }
            }
        };
        _this.isTooltipNeeded = function () {
            if (_this.props.smart) {
                var trigger = ReactDOM.findDOMNode(_this.triggerRef.current);
                if (trigger.scrollWidth <= trigger.offsetWidth) {
                    return false;
                }
            }
            return true;
        };
        _this.openTooltip = function (event) {
            _this.setState({ open: true }, function () {
                if (_this.tooltipRef.current) {
                    if (_this.isTooltipNeeded()) {
                        _this.setTooltipStyle();
                    }
                    else {
                        _this.setState({ open: false });
                    }
                }
            });
            if (_this.props.children.props.onMouseEnter) {
                _this.props.children.props.onMouseEnter(event);
            }
        };
        _this.handleMouseEnter = function (event) {
            if (_this.props.delay) {
                if (!_this.timer) {
                    _this.timer = window.setTimeout(function () {
                        _this.openTooltip(event);
                    }, _this.props.delay);
                }
            }
            else {
                _this.openTooltip(event);
            }
        };
        _this.state = {
            arrowPosition: props.position,
            position: {
                top: 0,
                left: 0,
            },
            style: {},
            open: false,
        };
        _this.tooltipRef = React.createRef();
        _this.triggerRef = React.createRef();
        return _this;
    }
    Tooltip.prototype.componentDidUpdate = function (props) {
        if (this.props !== props) {
            this.setTooltipStyle();
        }
    };
    Tooltip.prototype.render = function () {
        var _a = this.props, arrow = _a.arrow, appendToBody = _a.appendToBody, tooltip = _a.tooltip, children = _a.children, __ = _a.position, props = __rest(_a, ["arrow", "appendToBody", "tooltip", "children", "position"]);
        var tooltipWrapper = (React.createElement(TooltipWrapper, __assign({}, props, { innerRef: this.tooltipRef, arrow: arrow, onMouseLeave: this.handleMouseLeave, position: this.state.arrowPosition, style: this.state.style }), tooltip));
        return (React.createElement(Wrapper, null,
            React.createElement(RefWrapper, { ref: this.triggerRef }, React.cloneElement(children, {
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave,
            })),
            this.state.open &&
                appendToBody &&
                ReactDOM.createPortal(tooltipWrapper, document.body),
            this.state.open && !appendToBody && tooltipWrapper));
    };
    Tooltip.defaultProps = {
        arrow: false,
        position: 'Bottom',
        appendToBody: true,
    };
    return Tooltip;
}(React.Component));
export { Position };
export default Tooltip;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Tooltip.js.map